import { createBrowserHistory, createMemoryHistory } from 'history';
import { isSSR } from '../utils/utils';

const history = isSSR() ? createMemoryHistory() : createBrowserHistory();

export default history;
